module.exports = __webpack_public_path__ + "img/mtc-master-logo.4396c5ea.png";